module.exports = __webpack_public_path__ + "static/pic02-f5ca0d5c14482c94113f52a3cdb0e5a1.jpg";